import { render, staticRenderFns } from "./ListFeeds.vue?vue&type=template&id=3bb94f2d&scoped=true"
import script from "./ListFeeds.vue?vue&type=script&lang=ts"
export * from "./ListFeeds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb94f2d",
  null
  
)

export default component.exports